import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material/styles';

export const BitbucketIcon = () => {
  const theme = useTheme();
  const { mode } = theme.palette;

  return (
    <SvgIcon
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_336_115)">
        <path
          d="M54.4 0H9.6C4.29807 0 0 4.29807 0 9.6V54.4C0 59.7019 4.29807 64 9.6 64H54.4C59.7019 64 64 59.7019 64 54.4V9.6C64 4.29807 59.7019 0 54.4 0Z"
          fill={mode === 'dark' ? '#fff' : '#D9D9D9'}
        />
        <path
          d="M52.75 16.25C52.7811 16.07 52.7723 15.8854 52.7244 15.7092C52.6764 15.533 52.5904 15.3695 52.4725 15.23C52.3545 15.0906 52.2074 14.9788 52.0416 14.9023C51.8757 14.8258 51.6952 14.7867 51.5125 14.7875H12.5625C12.3789 14.7848 12.1969 14.8226 12.0295 14.8983C11.8621 14.974 11.7134 15.0856 11.5941 15.2252C11.4747 15.3648 11.3876 15.5291 11.339 15.7062C11.2903 15.8833 11.2813 16.069 11.3125 16.25L17 51.125C17.0476 51.4186 17.1984 51.6857 17.4252 51.8781C17.652 52.0706 17.9401 52.1758 18.2375 52.175H45.8625C46.4875 52.175 47.0125 51.7375 47.1125 51.125L52.75 16.25ZM36.375 39.6H27.7125L25.375 27.35H38.475L36.375 39.6Z"
          fill="#2684FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_336_115">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
